module.exports = __webpack_public_path__ + "static/media/SDGIcons_5.e9c2c5f5.png";